import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor() { }

  static CopyToClipBoard(text: string) {
    const listener = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/html', text);
      e.clipboardData.setData('text/plain', text);
      e.preventDefault();
    };
    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
  }

//   static thenByDescending<T>(...selectors: Array<(item: T) => any>): (a: T, b: T) => number {
//   return (a: T, b: T) => {
//     for (const selector of selectors) {
//       const aVal = selector(a);
//       const bVal = selector(b);

//       const aIsNull = aVal === null || aVal === undefined || aVal === '';
//       const bIsNull = bVal === null || bVal === undefined || bVal === '';

//       if (aIsNull && bIsNull) continue;   // both empty, check next key
//       if (aIsNull) return 1;              // nulls always go last
//       if (bIsNull) return -1;             // nulls always go last

//       const aNorm = aVal instanceof Date ? aVal.getTime() : (typeof aVal === 'string' ? Date.parse(aVal) || 0 : aVal);
//       const bNorm = bVal instanceof Date ? bVal.getTime() : (typeof bVal === 'string' ? Date.parse(bVal) || 0 : bVal);

//       if (aNorm !== bNorm) {
//         return bNorm - aNorm;
//       }
//     }
//     return 0;
//   };
// }

static thenByDescending<T>(...selectors: Array<(item: T) => any>): (a: T, b: T) => number {
  return (a: T, b: T) => {
    for (const selector of selectors) {
      const aVal = selector(a);
      const bVal = selector(b);

      const aNorm = this.normalize(aVal);
      const bNorm = this.normalize(bVal);

      if (aNorm !== bNorm) {
        return bNorm - aNorm; // descending; nulls (-Infinity) always sink to the bottom
      }
    }
    return 0;
  };
}

 static normalize(val: any): number {
  if (val === null || val === undefined || val === '') {
    return Number.NEGATIVE_INFINITY; // always treated as smallest
  }
  if (val instanceof Date) {
    return val.getTime();
  }
  if (typeof val === 'string') {
    const parsed = Date.parse(val);
    return isNaN(parsed) ? Number.NEGATIVE_INFINITY : parsed;
  }
  return typeof val === 'number' ? val : Number.NEGATIVE_INFINITY;
}
}
